import { z } from 'zod';

import { schemaEuropacePartnerId } from '../LoanRequest/Europace/Partner.subschema';

export const schemaEuropacePlatform = z.object({
    partnerId: schemaEuropacePartnerId.nullable(),
});

export type SchemaEuropacePlatform = z.infer<typeof schemaEuropacePlatform>;
